import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { Menu } from 'amphitheatre';
import { FiLogOut } from 'react-icons/fi';

import { deleteTokens } from '../../Redux/Tokens';
import Logo from './logo.png';

import { Home, Download, FAQ, Rules, Tutorials, Updates } from '../Pages';
import { BusinessTemplate } from '../Pages/BusinessPlan';
import Error404 from './Error404';
import Footer from '../Footer';

import { rawURL } from '../../index';

const connector = connect(undefined, { _deleteTokens: deleteTokens });

type Props = ConnectedProps<typeof connector>;

function Dashboard({ _deleteTokens }: Props): React.ReactElement {
  const history = useHistory();
  const location = useLocation();

  return (
    <div style={{ display: 'flex', flexFlow: 'column', minHeight: '100vh' }}>
      <Menu
        activeId={location.pathname.substr(1)}
        cover
        onMenuClick={(id) => {
          if (id === 'logout') {
            _deleteTokens();
            history.push('/');
            return;
          }

          const to = `/${id}`;
          if (location.pathname !== to) {
            history.push(to);
          }
        }}
        imgObj={
          <a
            href={`https://${rawURL}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img
              src={Logo}
              style={{ height: '32px', padding: '0.5rem' }}
              alt="logo"
            />
          </a>
        }
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 9000,
        }}
      >
        <Menu.Item id="">Home</Menu.Item>
        <Menu.Dropdown label="Information">
          <Menu.Item id="updates">Updates</Menu.Item>
          <Menu.Item id="faq">FAQs</Menu.Item>
        </Menu.Dropdown>
        <Menu.Item id="tutorials">Tutorials</Menu.Item>
        <Menu.Item id="downloads">Downloads</Menu.Item>
        <Menu.Divider />
        <Menu.Item id="logout">
          Logout&nbsp;
          <FiLogOut />
        </Menu.Item>
      </Menu>
      <div style={{ flexGrow: 1 }}>
        <Switch>
          <Route path="/faq">
            <FAQ />
          </Route>
          <Route path="/updates">
            <Updates />
          </Route>
          <Route path="/downloads">
            <Download />
          </Route>
          <Route path="/tutorials">
            <Tutorials />
          </Route>
          <Route path="/business-plan-template">
            <BusinessTemplate />
          </Route>
          <Route path="/rules">
            <Rules />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="*">
            <Error404 />
          </Route>
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

export default connector(Dashboard);
